<input type="text" placeholder="Time" disabled class="form-control" />
